<template>
    <div>
        <base-loading :visible="isLoading" />
        <edit-grace-period :item="item" :isOpen="editItem" @close="editItem = false" @updated="doSearch"/>
        <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-lg="2" vs-sm="4" vs-xs="12" class="p-1">
                <search-input v-model="search" @handleSearch="doSearch" />
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <client-table :items="items" @loadMore="loadMore()" @edit="edit" />
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import ClientTable from './components/ClientTable.vue';
import SearchInput from '@/views/app/components/inputs/SearchInput.vue';
import request from './request';
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
import EditGracePeriod from './components/EditGracePeriod.vue';

export default {
    components: { ClientTable, SearchInput, BaseLoading, EditGracePeriod },
    data() {
        return {
            items: [],
            item: { ClientId: null, ClientName: null, days: '48', gracePeriod: 0 },
            editItem:false,
            clientList: [],
            filters: { client: null },
            search: '',
            page: 1,
            lastPage: 1,
            isLoading: false
        }
    },
    methods: {
        getClients() {
            request.getClients()
                .then(response => {
                    console.log(response);
                    this.clientList = [...response.data]
                })
                .catch(response => {
                    console.log(response)
                })
        },
        doSearch() {
            this.page = 1
            this.getList()
        },
        getList() {
            const payload = {
                search: this.search,
                page: this.page
            }
            this.isLoading = true
            request.getList(payload)
                .then(response => {
                    const data = response.data.data.map(el => ({
                        ...el,
                        gracePeriod: el.days / 24,
                    }))
                    if (this.page === 1) {
                        this.items = [...data]
                    } else {
                        this.items = [...this.items, ...data]
                    }
                    this.lastPage = response.data.last_page
                    this.page = response.data.current_page
                    this.isLoading = false
                })
                .catch(response => {
                    this.isLoading = false
                })
        },
        loadMore() {
            if (this.page >= this.lastPage) {
                return
            }
            this.page++
            this.getList()
        },
        edit(item) {
            this.item = { ...item }
            this.editItem = true
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style></style>